/**
 *  Created By Taesoo.Kim <devp015>
 */

import {CmApiPrefix as cmApiPrefix, SystemApiPrefix as sysApiPrefix} from 'utils'
import {pcDownloadFile} from '~/utils/files'

const initSetBackupSchedData = () => {
  return {
    device_backup_item_set: [],
    device_backup_pw: '',
    device_backup_sched_device_type: 1,
    device_backup_sched_set: {},
    device_backup_sched_type: 1,
    device_backup_sched_uname: '',
    device_id_list: [],
    device_backup_sched_remote_list: [],
    device_backup_sched_device_model_type: 20
  }
}

const initRemoteBackupData = () => {
  return {
    device_backup_sched_id: '',
    device_backup_sched_remote_login_name: '', // 원격 사용자 ID
    device_backup_sched_remote_login_pw: null,
    device_backup_sched_remote_prtc: 1, // 프로토콜
    device_backup_sched_remote_svr_ip: '', // 서버 주소
    device_backup_sched_remote_port: 22, // 포트
    device_backup_sched_remote_tams_yn: 0,
    device_backup_sched_remote_path_val: '',
    device_backup_sched_remote_use_yn: 1 // 사용
  }
}

export const state = () => ({
  deviceBackUpRemoteUrl: `${cmApiPrefix}/device-backup-sched/remote`, // 보관일수
  deviceDelPeriodUrl: `${sysApiPrefix}/general`, // 보관일수
  deviceBackUpUrl: `${cmApiPrefix}/device-backup-sched`, // 장비 백업 일정 추가, 수정
  deviceBackUpDeleteUrl: `${cmApiPrefix}/device-backup-sched/multi`, // 장비 백업 일정 삭제
  deviceBackUpFileUrl: `${cmApiPrefix}/device-backup/file`, // 장비 로컬 백업 파일 삭제
  deviceBackUpDownloadUrl: `${cmApiPrefix}/device-backup/file/download`, // 장비 로컬 백업 파일 다운로드
  deviceBackUpUploadUrl: `${cmApiPrefix}/device-backup/file/upload`, // 로컬 백업 파일 업로드
  deviceBackUpGetUrl: `${cmApiPrefix}/device-backup/file/{device_id}`, // 장비 로컬 백업 파일 목록 조회
  deviceBackUpManualUrl: `${cmApiPrefix}/device-backup/manual`, // 수동 백업 실행
  deviceBackUpRestoreUrl: `${cmApiPrefix}/device-restore/manual`, // 복구 시작
  deviceBackUpUnzipUrl: `${cmApiPrefix}/device-unzip_restore_file`, // 압축 해제,
  deviceBackUpApplyUrl: `${cmApiPrefix}/device-backup-sched/apply`,
  deviceBackUpCancelUrl: `${cmApiPrefix}/device-backup-sched/cancel`,

  initRemoteId: null,
  delPeriodData: 60,
  getLocalBackupSchedData: [],
  setBackupSchedData: initSetBackupSchedData(),
  clearBackupSchedData: initSetBackupSchedData(),
  backupRemoteData: initRemoteBackupData(),
  backupRemoteList: [],
  getRemoteBackupSchedData: [],
  getBackupFileData: [],
  setManualBackupData: {
    backup_item_set: [],
    backup_pw: '',
    device_id: 1
  },
  getBackupFileDownloadData: {
    device_backup_file_id_list: []
  },
  delBackupFileData: {
    device_backup_file_id_list: []
  },
  setBackupRestoreData: {
    device_backup_file_uname: '',
    device_id: '',
    device_backup_pw: '',
    restore_item_set: []
  },
  resultMsg: {}
})

export const mutations = {
  getBackupSchedDataAction (state, data) {
    if (data.type === 1) {
      state.getLocalBackupSchedData = data.result
    } else if (data.type === 2) {
      state.getRemoteBackupSchedData = data.result
    }
  },
  resetBackupFileDataAction (state) {
    state.getBackupFileData = []
  },
  getBackupFileDataAction (state, data) {
    state.getBackupFileData = data
  },
  getDelPeriodDataAction (state, data) {
    state.delPeriodData = _.cloneDeep(data.msg)
  },
  clearBackupSchedDataAction (state, data) {
    state.setBackupSchedData = _.cloneDeep(data)
  },
  setResultMsgData (state, data) {
    state.resultMsg = data.msg
  },
  setInitRemoteId (state, data) {
    state.initRemoteId = data
  },
  setBackupRemoteData (state, data) {
    const remoteData = _.cloneDeep(data)

    state.backupRemoteData.device_backup_sched_id = remoteData.device_backup_sched_id
    state.backupRemoteData.device_backup_sched_remote_id = remoteData.device_backup_sched_remote_id
    state.backupRemoteData.device_backup_sched_remote_login_name = remoteData.device_backup_sched_remote_login_name
    state.backupRemoteData.device_backup_sched_remote_login_pw = remoteData.device_backup_sched_remote_login_pw
    state.backupRemoteData.device_backup_sched_remote_prtc = remoteData.device_backup_sched_remote_prtc
    state.backupRemoteData.device_backup_sched_remote_svr_ip = remoteData.device_backup_sched_remote_svr_ip
    state.backupRemoteData.device_backup_sched_remote_port = remoteData.device_backup_sched_remote_port
    state.backupRemoteData.device_backup_sched_remote_tams_yn = remoteData.device_backup_sched_remote_tams_yn
    state.backupRemoteData.device_backup_sched_remote_path_val = remoteData.device_backup_sched_remote_path_val
    state.backupRemoteData.device_backup_sched_remote_use_yn = remoteData.device_backup_sched_remote_use_yn
  },
  getBackupRemoteList (state, data) {
    state.backupRemoteList = _.cloneDeep(data)
  }
}

export const actions = {
  async getDelPeriodDataAction ({commit, state}) {
    let bRet = false

    const apiUrl = `${state.deviceDelPeriodUrl}?key=cm.system.backup.delete_term`

    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getDelPeriodDataAction', data.result)
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setDelPeriodDataAction ({commit, state}, periodData) {
    let bRet = false

    const param = {
      key: 'cm.system.backup.delete_term',
      val: periodData
    }
    const data = await this.$axios.$put(`${state.deviceDelPeriodUrl}`, param, {successAlert: false})

    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async getBackupSchedDataAction ({commit, state}, param) {
    let bRet = false
    let apiUrl = `${state.deviceBackUpUrl}/${param.device_backup_sched_type}`
    if (param.devicebackup_sched_id > -1) {
      apiUrl += `/${param.devicebackup_sched_id}`
    }
    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getBackupSchedDataAction',
        {
          type: param.device_backup_sched_type,
          result: data.result
        }
      )
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setBackupSchedDataAction ({commit, state}, {txtFlg, backupType}) {
    let bRet = false
    let data = {}
    const params = {
      device_backup_item_set: state.setBackupSchedData.device_backup_item_set,
      device_backup_pw: state.setBackupSchedData.device_backup_pw,
      device_backup_sched_device_model_type: state.setBackupSchedData.device_backup_sched_device_model_type,
      device_backup_sched_device_type: state.setBackupSchedData.device_backup_sched_device_type,
      device_backup_sched_set: JSON.stringify(state.setBackupSchedData.device_backup_sched_set),
      device_id_list: _.map(state.setBackupSchedData.device_id_list),
      device_backup_sched_type: state.setBackupSchedData.device_backup_sched_type,
      device_backup_sched_uname: state.setBackupSchedData.device_backup_sched_uname
    }
    if (txtFlg === 'add' && backupType === 1) { // 로컬 백업 추가
      data = await this.$axios.$post(`${state.deviceBackUpUrl}`, params)
    } else if (txtFlg === 'edit' || backupType === 2) { // 로컬 백업 편집, 원격 백업 추가/편집
      params.device_backup_sched_id = state.initRemoteId
      data = await this.$axios.$put(`${state.deviceBackUpUrl}`, params)
    }
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async initBackupRemoteId ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.deviceBackUpUrl}/init`, payload, {successAlert: false})
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async addBackupRemote ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_backup_sched_id: state.backupRemoteData.device_backup_sched_id,
        device_backup_sched_remote_login_name: state.backupRemoteData.device_backup_sched_remote_login_name, // 원격 사용자 ID
        device_backup_sched_remote_login_pw: state.backupRemoteData.device_backup_sched_remote_login_pw,
        device_backup_sched_remote_prtc: state.backupRemoteData.device_backup_sched_remote_prtc,
        device_backup_sched_remote_svr_ip: state.backupRemoteData.device_backup_sched_remote_svr_ip, // 서버 주소
        device_backup_sched_remote_port: state.backupRemoteData.device_backup_sched_remote_port, // 포트
        device_backup_sched_remote_tams_yn: state.backupRemoteData.device_backup_sched_remote_tams_yn,
        device_backup_sched_remote_path_val: state.backupRemoteData.device_backup_sched_remote_path_val,
        device_backup_sched_remote_use_yn: state.backupRemoteData.device_backup_sched_remote_use_yn// 사용
      }
      res = await this.$axios.$post(`${state.deviceBackUpRemoteUrl}`, params, {successAlert: true, loading: true})
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async editBackupRemote ({commit, state}, {isSuccess}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_backup_sched_id: state.backupRemoteData.device_backup_sched_id,
        device_backup_sched_remote_id: state.backupRemoteData.device_backup_sched_remote_id,
        device_backup_sched_remote_login_name: state.backupRemoteData.device_backup_sched_remote_login_name, // 원격 사용자 ID
        device_backup_sched_remote_login_pw: state.backupRemoteData.device_backup_sched_remote_login_pw,
        device_backup_sched_remote_prtc: state.backupRemoteData.device_backup_sched_remote_prtc,
        device_backup_sched_remote_svr_ip: state.backupRemoteData.device_backup_sched_remote_svr_ip, // 서버 주소
        device_backup_sched_remote_port: state.backupRemoteData.device_backup_sched_remote_port, // 포트
        device_backup_sched_remote_tams_yn: state.backupRemoteData.device_backup_sched_remote_tams_yn,
        device_backup_sched_remote_path_val: state.backupRemoteData.device_backup_sched_remote_path_val,
        device_backup_sched_remote_use_yn: state.backupRemoteData.device_backup_sched_remote_use_yn// 사용
      }
      res = await this.$axios.$put(`${state.deviceBackUpRemoteUrl}`, params, {successAlert: isSuccess})
      return res
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getBackupRemote ({commit, state}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`${state.deviceBackUpRemoteUrl}/${state.initRemoteId}`, {loading: true})
      if (res.code === 'ok') {
        commit('getBackupRemoteList', res.result)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delBackupRemote ({commit, state}, payload) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const params = {
        device_backup_sched_id: state.initRemoteId,
        device_backup_sched_remote_id_list: payload
      }
      res = await this.$axios.$delete(`${state.deviceBackUpRemoteUrl}`, {
        data: params
      }, {successAlert: true, loading: true})
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async delBackupDataAction ({commit, state}, item) {
    let bRet = false
    let data = ''
    if (item.device_backup_sched_id_list) {
      data = await this.$axios.$delete(`${state.deviceBackUpDeleteUrl}`,
        {data: item},
        {
          failAlert: false
        }
      )
    } else if (item.device_backup_file_list) {
      data = await this.$axios.$delete(`${state.deviceBackUpFileUrl}`, {data: item}, {successAlert: false})
    }

    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async getBackupFileDataAction ({commit, state}, param) {
    commit('resetBackupFileDataAction')
    const apiUrl = `${state.deviceBackUpFileUrl}/${param.device_id}`
    const data = await this.$axios.$get(apiUrl)
    if (data.code === 'ok') {
      commit('getBackupFileDataAction', data.result)
    }
    return data
  },
  async setManualBackupFileDataAction ({commit, state}) {
    let bRet = false
    const data = await this.$axios.$post(`${state.deviceBackUpManualUrl}`, state.setManualBackupData)
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async setRestoreBackupFileDataAction ({commit, state}) {
    const data = await this.$axios.$post(`${state.deviceBackUpRestoreUrl}`, state.setBackupRestoreData, {successAlert: false})
    return data
  },
  async uploadBackupFileAction ({commit, state}, formData) {
    let bRet = false
    const data = await this.$axios.$post(`${state.deviceBackUpUploadUrl}`, formData)
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  },
  async downloadBackupFileAction ({commit, state}, fileList) {
    let bRet = false
    try {
      const result = await this.$axios.$file(`${state.deviceBackUpDownloadUrl}`, fileList, {
        responseType: 'blob',
        method: 'post',
        successAlert: false,
        returnErr: true
      })
      if (result.code !== undefined) {
        const blob = new Blob([result.data])
        const reader = new FileReader()
        const _this = this
        reader.onload = () => {
          const msgObj = JSON.parse(reader.result)
          const msgTxt = msgObj.result.msg
          _this.$router.app.$alertPopUp.show(msgTxt)
        }
        reader.readAsText(blob)
      } else {
        const nameData = result.fileName.replace('UTF-8\'\'', '')
        pcDownloadFile(result.data, nameData)
      }
      bRet = true
    } catch (e) {
      bRet = false
    }
    return bRet
  },
  async applyDeviceBackUpAction ({commit, state}, param) {
    let bRet = false
    let data = ''
    if (param === 'apply') {
      data = await this.$axios.$put(`${state.deviceBackUpApplyUrl}`, '', {applyMsg: true})
    } else {
      data = await this.$axios.$put(`${state.deviceBackUpCancelUrl}`, '', {cancelMsg: true})
    }
    if (data.code === 'ok') {
      bRet = true
    } else {
      commit('setResultMsgData', data.result)
    }
    return bRet
  }
}

export const getters = {
  compareEditData () {
    const bRet = false
    return bRet
  }
}

export const strict = false
